// --- Dependencies -------------------------------------------------------------------------------
import { NavLink, useLocation } from "react-router-dom";
// --- Our Modules --------------------------------------------------------------------------------
import useNavTabs from "@/hooks/useNavTabs";
import { isSectionReentry } from "@/utils";
import Icon from "@/UI/atoms/Icon";
import OrganizationSwitcher from "@/UI/components/OrganizationSwitcher";
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
/**
 * The desktop navigation, on the inline-start edge — the right in Arabic, the left in English, with
 * neither written down. The icon comes first in the markup for the same reason: it belongs at the
 * start of the row whichever way the row runs.
 */
export default function SideBar() {
    const { tabs, footerTabs } = useNavTabs();
    const { pathname } = useLocation();

    return (
        <aside className="side-bar">
            <OrganizationSwitcher />
            <span className="side-bar__divider" />

            <nav className="side-bar__nav">
                {tabs.map((tab) => (
                    <NavLink
                        key={tab.path}
                        to={tab.path}
                        end={tab.path === "/"}
                        replace={isSectionReentry(tab.path, pathname)}
                        className={({ isActive }) => `side-bar__tab${isActive ? " side-bar__tab--active" : ""}`}
                    >
                        <Icon name={tab.icon} />
                        <span className="side-bar__tab-label">{tab.label}</span>
                    </NavLink>
                ))}
            </nav>

            {/* Pushed to the foot by the nav above it, which takes the free space. */}
            {footerTabs.length > 0 && (
                <nav className="side-bar__footer">
                    <span className="side-bar__divider" />
                    {footerTabs.map((tab) => (
                        <NavLink
                            key={tab.path}
                            to={tab.path}
                            replace={isSectionReentry(tab.path, pathname)}
                            className={({ isActive }) => `side-bar__tab side-bar__tab--quiet${isActive ? " side-bar__tab--active" : ""}`}
                        >
                            <Icon name={tab.icon} />
                            <span className="side-bar__tab-label">{tab.label}</span>
                        </NavLink>
                    ))}
                </nav>
            )}
        </aside>
    );
}
